module.exports = __webpack_public_path__ + "static/media/chodba-prizemi-2.46d087d8.jpg";